import { cn } from "@/lib/utils";
import Badge from "@app/_components/Badge";
import Link from "@app/_components/Link";
import useTranslate from "@app/_hooks/useTranslate";
import { useMarket } from "@features/market/useMarket";
import { Button } from "@ui/button";
import { HeartIcon } from "lucide-react";
import type { ComponentProps } from "react";
import useWishlist from "../../hooks/useWishlist";

export default function WishlistButton({
  showLabel = false,
  className,
  ...props
}: ComponentProps<typeof Button> & { showLabel?: boolean }) {
  const t = useTranslate();
  const { data } = useWishlist();
  const market = useMarket();

  return (
    <Button
      className={cn("relative h-auto w-auto p-1 transition-none", className)}
      variant="link"
      size={showLabel ? undefined : "icon"}
      asChild
      {...props}
    >
      <Link
        locale={market.siteLocale}
        href="/account/wishlist"
        className="flex items-center gap-x-2"
      >
        <Badge badgeContent={data?.metadata?.totalItems}>
          <span className="sr-only">{t("wishlist")}</span>
          <HeartIcon strokeWidth={1} className="size-5" />
        </Badge>
        {showLabel && (
          <span>
            {t("saveForLater")} ({data?.metadata?.totalItems})
          </span>
        )}
      </Link>
    </Button>
  );
}
